import React, { useState } from 'react'
import httpClient from '../components/helpers/httpClient'
import './MobileLoginPage.css'
import { useNavigate, Link } from "react-router-dom"
import CircularProgress from '@mui/material/CircularProgress'
import { toast } from "react-toastify"
import logo_white from "../assets/logos/Logo-Vitruvi-transparant_Wit.png"

export default function MobileForgotPasswordPage() {
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [submitted, setSubmitted] = useState(false)

  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!email) {
      toast.error("Please enter your email address")
      return
    }

    setLoading(true)

    try {
      const data = { email }
      await httpClient.post(import.meta.env.VITE_API_URL + "/api/admin/reset-password", data)
      
      setSubmitted(true)
      toast.success("If an account with that email exists, a password reset link has been sent.")
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error(error.response.data.error || "Please enter a valid email address")
      } else {
        toast.error("An error occurred. Please try again.")
      }
    }

    setLoading(false)
  }

  const handleEnter = (event) => {
    if (event.key === "Enter") {
      event.preventDefault()
      handleSubmit(event)
    }
  }

  if (submitted) {
    return (
      <div className="mobile-login-page">
        <div className="mobile-login-container">
          <img src={logo_white} alt="Vitruvi logo" className="mobile-login-logo" />
          <div className="mobile-login-form">
            <h2 style={{ color: 'white', textAlign: 'center', marginBottom: '20px', fontSize: '20px' }}>Check Your Email</h2>
            <p style={{ color: 'rgba(255, 255, 255, 0.9)', textAlign: 'center', marginBottom: '10px', fontSize: '14px' }}>
              If an account with that email exists, we've sent you a password reset link.
            </p>
            <p style={{ color: 'rgba(255, 255, 255, 0.7)', textAlign: 'center', fontSize: '12px' }}>
              The link will expire in 2 hours.
            </p>
            <div className="mobile-login-footer">
              <Link to="/">Back to Login</Link>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="mobile-login-page">
      <div className="mobile-login-container">
        <img src={logo_white} alt="Vitruvi logo" className="mobile-login-logo" />
        <div className="mobile-login-form">
          <h2 style={{ color: 'white', textAlign: 'center', marginBottom: '20px', fontSize: '20px' }}>Forgot Password</h2>
          <p style={{ color: 'rgba(255, 255, 255, 0.9)', textAlign: 'center', marginBottom: '20px', fontSize: '14px' }}>
            Enter your email address and we'll send you a link to reset your password.
          </p>
          <div className="mobile-input-group">
            <input
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder='EMAIL'
              onKeyDown={handleEnter}
              className="mobile-login-input"
              type="email"
              disabled={loading}
            />
          </div>

          <button 
            type='button' 
            className='mobile-login-button' 
            onClick={handleSubmit} 
            disabled={loading}
          >
            {loading ? <CircularProgress color="inherit" size={24} /> : "SEND RESET LINK"}
          </button>
          
          <div className="mobile-login-footer">
            <Link to='/'>Back to Login</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

